<template>
  <div
    :class="{ pointer: hover && editable, 'editable block': userLanguages.length !== 0 }"
    @mouseover="hover = true"
    @mouseout="hover = false"
  >
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      :header-text="$t('Language skills')"
      :modal-id="'languages-modal'"
      :is-open="showModal"
      :save-state="saveState"
      data-test="languages-modal"
      @opened="handleModalOpened"
      @cancel="handleModalCancel"
      @save="handleModalSave"
    >
      <LanguageSelection></LanguageSelection>
    </BaseModal>
    <slot v-if="inactive" />
    <div v-else class="row" @click="handleClick">
      <div class="col-xs-11 col-sm-6">
        <div class="row">
          <template v-if="userLanguages.length === 0">
            <div class="col-xs-8">
              <strong class="btn btn-default btn-sm" data-test="add-languages">
                {{ $t('Add languages') }}
              </strong>
            </div>
          </template>
          <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
          <template v-for="language in userLanguages" :key="language.key">
            <div v-if="language.level" class="row m-0">
              <div class="col-xs-4">
                <strong>{{ $t(language.text) }}</strong>
              </div>
              <div class="col-xs-4">
                {{ $t(`lang${language.level}.text`) }}
              </div>
              <div class="col-xs-3">
                <span
                  :title="$t(`lang${language.level}.profile_descr`)"
                  data-toggle="tooltip"
                  data-html="true"
                  class="c-gray"
                >
                  <i class="zmdi zmdi-help" />
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-xs-1">
        <i v-show="hover && editable && userLanguages.length !== 0" class="zmdi zmdi-edit c-gray" />
      </div>
    </div>
  </div>
</template>

<script>
import enums from '@/utils/enum'
import { SET_EDIT_UNSAVED, UPDATE_USER_STATE } from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'
import { UPDATE_FREELANCER } from '@/state/apollo/accounts'
import { NetworkError } from '@/utils/notification'
import LanguageSelection from '@/components/LanguageSelection.vue'

export default {
  components: {
    LanguageSelection,
  },
  props: {
    initialLanguagesState: { type: Object, required: true },
    isMe: { type: Boolean, required: true },
  },
  data() {
    return {
      latestSavedState: {},
      inactive: true,
      hover: false,
      showModal: false,
      saveState: 'fresh',
    }
  },
  computed: {
    editable() {
      return this.isMe && this.$store.state.edit.on
    },
    userLanguages() {
      return this.$store.getters.userLanguages
    },
  },
  created() {
    this.$store.commit(UPDATE_USER_STATE, {
      fieldName: 'languages',
      fieldValue: this.initialLanguagesState,
    })
  },
  mounted() {
    this.inactive = false
  },
  methods: {
    handleClick() {
      if (this.editable) {
        this.showModal = !this.showModal
      }
    },
    handleModalOpened() {
      this.latestSavedState = JSON.parse(JSON.stringify(this.$store.state.user.languages))
    },
    handleModalCancel() {
      if (this.saveState !== 'saving' && this.showModal) {
        this.$store.commit(SET_EDIT_UNSAVED, false)
        this.$store.commit(UPDATE_USER_STATE, {
          fieldName: 'languages',
          fieldValue: this.latestSavedState,
        })
        this.showModal = false
      }
    },
    async handleModalSave() {
      await this.$store.dispatch(SET_EDIT_SAVING_STATE, true)
      this.$store.commit(SET_EDIT_UNSAVED, true)
      this.saveState = 'saving'
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_FREELANCER,
          variables: {
            input: {
              globalId: this.account.globalId,
              languages: this.userLanguages.map((language) => ({
                locale: language.key,
                level: language.level.toString(),
              })),
            },
          },
        })

        await this.$store.dispatch(SET_EDIT_SAVING_STATE, false)
        this.saveState = 'saved'
        setTimeout(() => {
          this.showModal = false
          this.saveState = 'fresh'
        }, 1000)
      } catch (e) {
        this.$store.commit(SET_EDIT_UNSAVED, false)
        await this.$store.dispatch(SET_EDIT_SAVING_STATE, false)
        new NetworkError({
          severity: enums.notification.severity.CRITICAL,
          ex: e,
        }).dispatch()
        setTimeout(() => {
          this.saveState = 'fresh'
        }, 2000)
      }
    },
  },
}
</script>
